import { Helmet } from "react-helmet-async";
import { env } from "@/src/common/constants/env";

interface PageHelmetProps {
	title: string;
}

export function PageHelmet({ title }: PageHelmetProps) {
	return <Helmet defaultTitle={env.APP_NAME} titleTemplate={`%s | ${env.APP_NAME}`} title={title} />;
}
